<script setup lang="ts">
/** Letter of Confirmation of Paid Up Capital — SG Incorporation (Post) */
import CddVarField from '../incorporation-pre/cdd/CddVarField.vue';
import SgPostSigners from './SgPostSigners.vue';
import { SG_POST_SIGNER_KEYS } from './sgPostSignersContext';
import './allotDoc.css';
</script>

<template>
  <div class="allot-doc">
    <div class="doc-head" style="text-align:left">
      <div class="doc-company"><CddVarField field-key="company_name" label="Company Name" /></div>
      <div class="doc-meta">
        (Company Registration No.: <CddVarField field-key="company_registration_no" label="Registration No." />)<br />
        <CddVarField field-key="company_registered_address" label="Company Registered Address" />
      </div>
    </div>

    <p class="doc-p">Date: <CddVarField field-key="letter_date" label="Letter Date" /></p>
    <p class="doc-p">
      To:<br />
      <CddVarField field-key="csp_name" label="CSP Name" /><br />
      <CddVarField field-key="csp_address_line1" label="CSP Address Line 1" /><br />
      <CddVarField field-key="csp_address_line2" label="CSP Address Line 2" />
    </p>

    <p class="doc-lbl-title">Subject: Letter of Confirmation of Paid Up Capital</p>
    <p class="doc-p">Dear Sir / Madam,</p>
    <p class="doc-p">
      I hereby confirm that I will inject the share capital of
      <CddVarField field-key="currency_symbol" label="Currency" />
      <CddVarField field-key="paid_up_capital_amount" label="Paid-Up Capital Amount" />
      into the Company's bank account upon the bank account being established or within
      <CddVarField field-key="capital_injection_days" label="Injection Days" />
      days from the date of incorporation of the Company, whichever is earlier. I will send a copy of the
      bank receipt as proof of the injection.
    </p>

    <p class="doc-p" style="margin-top:16px">Yours truly,</p>
    <p class="doc-p">for and on behalf of <CddVarField field-key="company_name" label="Company Name" /></p>
    <SgPostSigners :var-key="SG_POST_SIGNER_KEYS.paidUp" board-label="DIRECTOR — select one" />
  </div>
</template>
